<!-- Kept mounted rather than wrapped in @if, so the loader's own ngOnChanges reliably drives
     the spinner's show/hide instead of relying on component destruction to tear it down. -->
<myp-inline-loader
  [loading]="changingEmail"
  [fullScreen]="true"
  bdColor="rgba(0, 0, 0, 0.85)"
  spinnerName="changingEmail"
  [spinnerMessage]="'account.email_change_in_progress' | translate"
></myp-inline-loader>
<div class="edit-profile-container m-r-10 m-b-20">
  <div class="accountinfo">
    <fui-heading extraClasses="text-nowrap" [text]="'account.profile_and_cover_photo' | translate" [level]="5"></fui-heading>
    <div class="cover-photo" [ngStyle]="{ 'background-image': user.cover_photo ? 'url(' + user.cover_photo + ')' : 'url(./assets/images/studio-one-plus-profile-banner.png)' }">
      <div class="profile-photo-container">
        <img [src]="userService.profilePicture" [alt]="'profile.profile_photo_alt' | translate: { name: user.firstName + ' ' + user.lastName }" />
        <div class="edit-buttons d-flex align-items-center justify-content-center">
          <fa-icon icon="pencil" [ngbTooltip]="'account.change_profile_photo' | translate" class="circle-icon-btn m-r-5" (click)="showChangeProfilePhoto()" aria-hidden="true"></fa-icon>
          <fa-icon icon="times" [ngbTooltip]="'account.remove_profile_photo' | translate" class="circle-icon-btn" (click)="removeProfilePhoto()" aria-hidden="true"></fa-icon>
        </div>
      </div>
      <div class="cover-photo-edit-buttons">
        <fa-icon icon="pencil" [ngbTooltip]="'account.change_cover_photo' | translate" class="circle-icon-btn m-r-5" (click)="showChangeCoverPhoto()" aria-hidden="true"></fa-icon>
        <fa-icon icon="times" [ngbTooltip]="'account.delete_cover_photo' | translate" class="circle-icon-btn" (click)="removeCoverPhoto()" aria-hidden="true"></fa-icon>
      </div>
    </div>

    <div class="row">
      <div class="col-12 m-t-50">
        <fui-heading [text]="'account.member_since' | translate" [level]="5"></fui-heading>
        <p>{{ user.createdTime | date: "MMMM Do, YYYY" }}</p>
      </div>
      <div class="col-12">
        <form id="account_form" class="form-horizontal text-left row m-t-50 m-b-50" name="basic_profile">
          <div class="form-group text-left col-md-12">
            <fui-heading [text]="'account.about' | translate" [level]="5"></fui-heading>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="firstName">{{ "account.first_name" | translate }}*</label>
            <input
              type="text"
              class="form-control"
              name="firstName"
              id="firstName"
              [(ngModel)]="user.firstName"
              [placeholder]="'account.enter_name' | translate"
              autocomplete="given-name"
              [disabled]="user.community_name_change?.locked"
              required
            />
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="lastName">{{ "account.last_name" | translate }}*</label>
            <input
              type="text"
              class="form-control"
              name="lastName"
              id="lastName"
              [(ngModel)]="user.lastName"
              [placeholder]="'account.enter_last_name' | translate"
              autocomplete="family-name"
              [disabled]="user.community_name_change?.locked"
              required
            />
          </div>

          @if (user.community_name_change?.last_changed_at) {
            <div class="form-group col-md-12">
              <small class="text-muted">
                {{ "account.community_name.last_changed" | translate: { date: (user.community_name_change.last_changed_at | date: "MMMM Do, YYYY") } }}
                @if (user.community_name_change.locked) {
                  {{ "account.community_name.next_allowed" | translate: { date: (user.community_name_change.next_allowed_at | date: "MMMM Do, YYYY") } }}
                }
              </small>
            </div>
          }

          <div class="form-group col-md-12">
            <label class="control-label" for="tagline">{{ "account.tagline" | translate }}</label>
            <input type="text" class="form-control" name="tagline" id="tagline" [(ngModel)]="tagline" [placeholder]="'com.100_characters' | translate" aria-describedby="taglineHelp" />
          </div>

          <div class="form-group col-md-12">
            <label class="control-label" for="description">{{ "account.description" | translate }}</label>
            <textarea
              name="description"
              id="description"
              [(ngModel)]="user.description"
              [placeholder]="'account.description_note' | translate"
              class="form-control"
              aria-describedby="descriptionHelp"
              >{{ user.description }}</textarea
            >
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="email">{{ "account.email" | translate }}</label>
            <input
              type="text"
              class="form-control"
              name="email"
              id="email"
              [(ngModel)]="user.email"
              [placeholder]="'account.enter_email' | translate"
              autocomplete="email"
              aria-describedby="emailHelp"
              [disabled]="user.fender_user_details && user.fender_user_details?.provider != 'cognito'"
            />
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="phone">{{ "account.phone" | translate }}</label>
            <input type="phone" [(ngModel)]="user.phone" name="phone" class="form-control" id="phone" [placeholder]="'account.enter_phone' | translate" autocomplete="tel" />
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="native_language">{{ "sphere.account.language" | translate }}</label>
            <select class="form-control" id="native_language" name="native_language" [(ngModel)]="user.native_language" autocomplete="language">
              @for (language of languages; track language) {
                <option [ngValue]="language.code">{{ language.title }}</option>
              }
            </select>
          </div>

          <div class="form-group col-md-6">
            <label class="control-label" for="country">{{ "account.country_region" | translate }}</label>
            <select class="form-control" id="country" name="country" [(ngModel)]="user.country" autocomplete="country-name">
              @for (country of countries; track country) {
                <option [ngValue]="country.code">{{ country.title }}</option>
              }
            </select>
          </div>

          <div class="form-group col-12 col-md-6">
            <label class="control-label" for="birthday">{{ "account.birthday" | translate }}</label>
            <div
              class="form-control pointer"
              tabindex="0"
              (keyup.enter)="showDatePicker()"
              (keydown.space)="showDatePicker(); $event.preventDefault()"
              name="birthday"
              id="birthday"
              (click)="showDatePicker()"
              autocomplete="bday"
              role="button"
            >
              {{ birthday ? (birthday | date) : ("account.none_selected" | translate) }}
              <fa-icon icon="calendar" class="m-l-5"></fa-icon>
            </div>
          </div>

          <div class="form-group col-md-12 m-y-20">
            <myp-switch [active]="isPublic" [label]="'account.make_profile_public' | translate" [labelToRight]="true" (toggle)="isPublic = !isPublic"></myp-switch>
            <small id="publicCheckHelp" class="pad text-muted">{{ "account.public_profile_description" | translate }}</small>
          </div>

          <div class="col-md-12">
            <button class="btn btn-secondary" (click)="saveAccountInfo()">
              @if (saving) {
                <div role="status">{{ saveButtonText }}</div>
              }
              @if (!saving) {
                <div>
                  <fa-icon icon="check"></fa-icon>
                  &nbsp;{{ "account.save_button" | translate }}
                </div>
              }
            </button>
          </div>
        </form>

        <div class="m-y-50">
          <myp-account-skills></myp-account-skills>
        </div>

        <div class="m-y-50">
          <myp-account-addresses></myp-account-addresses>
        </div>

        @if (isExternalDeveloper) {
          <div class="m-y-50">
            <fui-heading [text]="'account.developer_settings' | translate" [level]="5"></fui-heading>
            <p class="text-sm m-t-10">{{ "account.developer_public_key_help" | translate }}</p>
            <input
              type="file"
              accept=".pem,.pub,.key,.txt"
              class="m-b-10"
              [attr.aria-label]="'account.upload_public_key' | translate"
              #devKeyInput
              (change)="uploadDeveloperKey(devKeyInput)"
              [disabled]="uploadingDeveloperKey"
            />
            @if (uploadingDeveloperKey) {
              <fa-icon icon="spinner" animation="spin" class="m-l-5"></fa-icon>
            }
            @if (developerKeyMessage) {
              <p class="text-sm m-t-10" [class.text-danger]="developerKeyError" [class.text-success]="!developerKeyError">{{ developerKeyMessage }}</p>
            }
          </div>
        }

        <div class="m-y-50">
          <fui-heading [text]="'account.account_actions' | translate" [level]="5"></fui-heading>
          @if (!user.fender_user_details || user.fender_user_details?.provider == "cognito") {
            <button class="btn btn-secondary btn-sm m-b-10 m-r-5" (click)="openChangePassword()">
              <fa-icon icon="key"></fa-icon>
              {{ "account.change_password" | translate }}
            </button>
          }
          <button class="btn btn-secondary btn-sm m-b-10 m-r-5" (click)="downloadData()">
            <fa-icon icon="download"></fa-icon>
            {{ "account.download_data" | translate }}
          </button>
          <button class="btn btn-secondary btn-sm m-b-10" (click)="deleteData()">
            <fa-icon icon="trash"></fa-icon>
            {{ "account.delete_data" | translate }}
          </button>
        </div>

        <!-- Connections used to be its own account section; it lives here now. The component
             draws its own "Connections" heading and intro when not in compact mode, so this
             wrapper only supplies the same vertical rhythm as the blocks around it. -->
        @if (appService.app == "fender" && $any(env.features)?.discordLinking) {
          <div class="m-y-50">
            <myp-account-connections></myp-account-connections>
          </div>
        }

        <div class="m-y-50">
          <fui-heading [text]="'account.login_method' | translate" [level]="5"></fui-heading>
          @if (user.fender_user_details?.provider == "cognito") {
            <p>{{ "account.email_and_password" | translate }}</p>
          }
          @if (user.fender_user_details?.provider != "cognito") {
            <div class="d-flex align-items-center m-y-20">
              <myp-svg [id]="user.fender_user_details?.provider + '-logo'" class="svg-neutral" width="20" height="20"></myp-svg>
              <strong class="m-l-5">{{ user.fender_user_details?.provider | sentenceCase }}</strong>
            </div>
          }
          @if (user.fender_user_details?.provider != "cognito") {
            <div class="d-flex align-items-center">
              <button class="btn btn-secondary btn-sm m-r-5" (click)="appService.showModal(newPasswordModalContent)">
                {{ "account.switch_to_email_password_login" | translate }}
                @if (removingSocialLogin) {
                  <fa-icon icon="spinner" class="m-l-5" animation="spin"></fa-icon>
                }
              </button>
              <fa-icon icon="question-circle" class="m-l-5" placement="top" [ngbTooltip]="'account.login_method_tooltip' | translate"></fa-icon>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #captchaModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="hardware-history-details">{{ "account.verify_human" | translate }}</h4>
    <button ngbAutofocus class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="captcha d-flex justify-content-center">
      <re-captcha (resolved)="resolved($event)" siteKey="{{ env.reCaptchaKey }}"></re-captcha>
    </div>
  </div>
</ng-template>

<ng-template #newPasswordModalContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-password-update">{{ "account.add_password_to_account" | translate }}</h4>
    <button ngbAutofocus class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label class="control-label">
        {{ "account.add_password_modal_description" | translate: { email: user.email, provider: (user.fender_user_details?.provider | sentenceCase) } }}
      </label>
      <div class="password-input">
        <input type="text" id="password" [(ngModel)]="newPassword" class="form-control" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" (click)="removeSocialLogin()">{{ "general.submit" | translate }}</button>
  </div>
</ng-template>
